import { Modal } from 'antd'
import React from 'react'
import ImportTestCaseForm from './ImportTestCaseForm'

const ImportTestCaseModal = (props) => {
    const { stateTestCase = {}, setStateTestCase = () => {} } = props
    return (
        <Modal
            closable={false}
            open={stateTestCase?.importTCModal}
            // onCancel={() => {
            //     setStateTestCase({
            //         ...stateTestCase,
            //         importTCModal: false,
            //     })
            // }}
            width={540}
            footer={null}
            centered
            title={'Import Test Cases'}
        >
            <ImportTestCaseForm
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
            />
        </Modal>
    )
}

export default ImportTestCaseModal
